<template>
  <div class="autoOrder">
    <!-- <div @click="handleDownload">1111</div> -->
    <div class="content">
      <!-- <div class="fx search">
        <el-input
          class="ipt_width"
          v-model="searchInfo.ticketName"
          @clear="handlerClear('ticketName')"
          clearable
          placeholder="请输入票名"
        ></el-input>
        <el-input
          class="ipt_width"
          v-model="searchInfo.orderNo"
          @clear="handlerClear('orderNo')"
          clearable
          placeholder="请输入订单号"
        ></el-input>

        <el-input
          class="ipt_width"
          v-model="searchInfo.phone"
          @clear="handlerClear('phone')"
          clearable
          placeholder="请输入手机号"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handlerClick"
          >搜索</el-button
        >
      </div> -->

      <my-eltable
        class="myTable"
        ref="mt"
        id="printTable"
        :tableData="tableData"
        :tabheight="tabheight"
        :tableHeader="tableHeader"
        :loading="loading"
        :isshow="isshow"
        :total="total"
        :isOperate="isOperate"
        :operateList="operateList"
        @handlerTable="handlerModify"
      >
      </my-eltable>
      <!-- 分页 -->
      <div class="fy">
        <el-pagination
          class="fx fend"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="sizes, prev, pager, next"
          :total="total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>确认退款吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handlerRefund">确 定</el-button>
      </span>
    </el-dialog>

  
  </div>
</template>

<script>
import { queryDifferencesPage} from "@/http/inventory.js";

import MyEltable from "../../components/el_table";

export default {
  components: { MyEltable },
  data() {
    return {
      loading: false,
      isshow: true,
      tabheight: "100%",
      tableHeader: [
        // 表头
        // { prop: "id", label: "序号" },
        { prop: "name", label: "商品名称" },
        { prop: "checkNum", label: "盘点盈亏" },
        { prop: "checkTotal", label: "盘点总计" },
        { prop: "date", label: "时间" },
        { prop: "unitName", label: "单位" },
        { prop: "checkRemark", label: "备注" },
      ],
      tableData: [],
      operateList: [
        { name: "退款", type: "primary", size: "mini", mark: 1 },
        // { name: "删除", type: "danger", size: "mini", mark: 2 },
        // {name:'库存',type:'info',size:'mini',mark:3},
      ],
      isOperate:false,
      currentPage: 1,
      pagesize: 10,
      total: 0,
      dialogFormVisible: false,
      form: {},
      imgUrl: "",
      checkedShops: [],
      shops: [],
      headers: {},
      sort: [],
      unit: [],
      isMain: false,
      radio: false,
      stock: ["限制", "不限制"],
      isModify: false,
      searchInfo: {},
      status:false,
      statusTitle:["待支付","已完成","已取消","已退款"],
      dialogVisible:false,
      lineInfo:{}
    };
  },
  created() {
    this.orderList()
  },
 
  methods: {
    
    handlerModify(val) {
      this.dialogVisible = true;
      this.lineInfo = val;
    },
    async handlerRefund() {
      let {orderNo } = this.lineInfo;
      let query = {
          orderNo
      }
      let res = await vendingRefund(query);
      console.log('res',res);
      if (res.code === 1) {
        this.$message({
          showClose: true,
          message: "申请退款成功",
          type: "success",
        });
        this.dialogVisible = false;
        this.commodityList();
      } else {
        this.$message({
          showClose: true,
          message: res.msg,
          type: "error",
        });
      }
    },
  
  
    handlerClear(val) {
      delete this.searchInfo[val];
      console.log(this.searchInfo);
    },
   
    handlerClick() {
      this.orderList(1);
    },
    async orderList(val) {
      if (val && val == 1) {
        
        this.currentPage = 1;
      }
      let query = {
        page: this.currentPage + "",
        limit: this.pagesize + "",
        ...this.searchInfo,
      };
      let res = await queryDifferencesPage(query);
      this.tableData = res.data.list;
      // this.tableData.forEach((item) => {
      //   item.statusTitle = this.statusTitle[item.orderStatus];
      //   item.payType = 0;
      // });
      this.total = res.data.totalCount;
    },
    //页码改变
    currentChange(val) {
      this.currentPage = val;
      this.orderList();
    },
    //handleSizeChange
    handleSizeChange(val) {
      this.pagesize = val;
      this.orderList();
    },
 
  },
};
</script>

<style lang="scss" >
.autoOrder {
  height: 100%;
  width: 100%;
  background: #f0f2f5;
  .content {
    width: 98%;
    // height: 900px;
    height: calc(100% - 37px);
    background: #ffffff;
    margin: 16px auto 0;
    padding: 10px;
  }
  .add_button {
    color: #fff;
    background: #18b3a3;
    border: #18b3a3;
  }
}

.fy {
  width: 96%;
  margin: 10px auto 0;
}
.fend {
  justify-content: flex-end;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #18b3a3;
  color: #fff;
}
.el-pagination.is-background .el-pager li.active {
  color: #fff;
  cursor: default;
}
.el-pagination.is-background .el-pager li:hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #18b3a3;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: #18b3a3;
  color: #fff;
}

.add_button:hover {
  background: #18b3a3;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.ipt_width {
  width: 240px;
  margin-right: 20px;
}
.select_width {
  width: 150px;
  margin-right: 20px;
}
.search {
  // margin-top: 10px;
  margin-bottom: 10px;
}
</style>